import { render } from "./ReceiptComponent.vue?vue&type=template&id=773e416b&scoped=true"
import script from "./ReceiptComponent.vue?vue&type=script&lang=js"
export * from "./ReceiptComponent.vue?vue&type=script&lang=js"

import "./ReceiptComponent.vue?vue&type=style&index=0&id=773e416b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773e416b"],['__file',"resources/js/components/admin/pos/ReceiptComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "773e416b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('773e416b', __exports__)) {
    api.reload('773e416b', __exports__)
  }
  
  module.hot.accept("./ReceiptComponent.vue?vue&type=template&id=773e416b&scoped=true", () => {
    api.rerender('773e416b', render)
  })

}


export default __exports__